import {
  CreateInvoiceDto,
  Invoice,
  PaymentPaginatedResponse,
  SessionPayment,
  UpdateSessionPaymentDto,
} from 'types/models';
import apiClient from './apiClient';

interface InvoicePaginatedResponse {
  data: Invoice[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

interface PaymentQuery {
  page?: number;
  limit?: number;
  estadoPago?: string;
  desde?: string;
  hasta?: string;
}

export const paymentService = {
  getAll: async (params?: PaymentQuery): Promise<PaymentPaginatedResponse> => {
    const { data } = await apiClient.get<PaymentPaginatedResponse>('/payments', { params: { page: 1, limit: 50, ...params } });
    return data;
  },

  getByPatient: async (patientId: string, params?: PaymentQuery): Promise<PaymentPaginatedResponse> => {
    const { data } = await apiClient.get<PaymentPaginatedResponse>(
      `/patients/${patientId}/payments`,
      { params: { page: 1, limit: 50, ...params } },
    );
    return data;
  },

  getById: async (id: string): Promise<SessionPayment> => {
    const { data } = await apiClient.get<SessionPayment>(`/payments/${id}`);
    return data;
  },

  update: async (id: string, payload: UpdateSessionPaymentDto): Promise<SessionPayment> => {
    const { data } = await apiClient.patch<SessionPayment>(`/payments/${id}`, payload);
    return data;
  },

  createInvoice: async (paymentId: string, payload: CreateInvoiceDto): Promise<Invoice> => {
    const { data } = await apiClient.post<Invoice>(`/payments/${paymentId}/invoices`, payload);
    return data;
  },

  getInvoices: async (paymentId: string): Promise<Invoice[]> => {
    const { data } = await apiClient.get<InvoicePaginatedResponse>(
      `/payments/${paymentId}/invoices`,
    );
    return data.data;
  },
};
